/** App-wide non-env constants. */
export const APP_NAME = "Comminova";
export const DEFAULT_LOCALE = "sv";
export const SESSION_STORAGE_KEY = "comminova:activeRestaurantId";

/**
 * Router `location.state` for navigations to `/admin` that should run the one-shot
 * role default redirect (e.g. cashier → terminal). Omit for explicit `/admin` visits
 * (e.g. Leave POS → dashboard).
 */
export type AdminNavigationState = {
  applyRoleDefaultLanding?: boolean;
};

export const adminEntryApplyRoleLandingState: AdminNavigationState = {
  applyRoleDefaultLanding: true,
};
